var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 67,
    viewBox: "0 0 67 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#AA367C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#4A2FBD"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient)",
    d: "M53.487 59.8059L58.7706 0H0L0.0690476 0.776083L5.27524 59.8143L5.31943 60.3056L29.163 67H29.5386L53.4373 60.3L53.4815 59.8087L53.487 59.8059ZM29.4364 13.0622H46.5132L45.9995 19.0922L29.1519 26.6632L29.4336 28.0255H45.2428L43.4227 49.1054L29.3756 53.0417L15.3341 49.111L14.4503 39.0163H20.231L20.695 44.1335L20.7391 44.6304L29.2596 46.9195H29.627L38.0535 44.5522L38.095 44.0581L38.8904 34.6055L38.9539 33.835H13.967L13.4422 27.7687L30.867 20.2284L30.5909 18.8605H12.6937L12.1828 13.0538H29.417L29.4364 13.0622Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.37166e3ad113e3e3f00d880ee144cf90.svg";
export { ForwardRef as ReactComponent };